export const getTaskPersonName = (task) => {
  const joinedName = [task?.person_first_name, task?.person_last_name].filter(Boolean).join(' ');
  return joinedName || task?.person?.full_name || '—';
};
